import { render, staticRenderFns } from "./DataValidation.vue?vue&type=template&id=1bab900c&scoped=true&"
import script from "./DataValidation.vue?vue&type=script&lang=js&"
export * from "./DataValidation.vue?vue&type=script&lang=js&"
import style0 from "./DataValidation.vue?vue&type=style&index=0&id=1bab900c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab900c",
  null
  
)

export default component.exports